(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bi/commons/utils/dnd/DnDManager"));
	else if(typeof define === 'function' && define.amd)
		define(["bi/commons/utils/dnd/DnDManager"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("bi/commons/utils/dnd/DnDManager")) : factory(root["bi/commons/utils/dnd/DnDManager"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__92__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 91);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinComponentDidLoadModules", function() { return mixinComponentDidLoadModules; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_3__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





/**
 * A HOC that will ensure AMD modules are loaded. Use of this HOC requires an AMD loader is available at runtime.
 *
 * The initializer will be called only once when all modules have loaded.
 *
 * The HOC will mount the component immediately unless mountOnLoad is 'true'.
 *
 * @param {Object} imports - key value pair of import name to require path
 * @param {Function=} initlaizer - an optional function which will be called once all imports have been resolved
 * @param {Boolean} mountOnLoad - if true, the wrapped component will only mount once all imports have resolved,
 *                                otherwise the wrapped component will mount immediately
 */
/* harmony default export */ __webpack_exports__["default"] = (function (imports, initializer, mountOnLoad) {
  let resolved;
  let promise;
  const names = [];
  const paths = [];
  Object.keys(imports).forEach(key => {
    paths.push(imports[key]);
    names.push(key);
  });

  function doRequire(instance) {
    if (!resolved) {
      if (!promise) {
        promise = new Promise(resolve => {
          window.require(paths, (...args) => {
            resolved = {};
            promise = null;
            names.forEach((name, i) => {
              resolved[name] = args[i];
            });
            initializer && initializer(resolved);
            resolve(resolved);
          });
        });
      }

      promise.then(() => {
        instance.forceUpdateOnce();
      });
    }
  }

  return function (WrappedComponent) {
    class RequireAMD extends react__WEBPACK_IMPORTED_MODULE_2__["Component"] {
      constructor(props) {
        super(props);

        _defineProperty(this, "forceUpdateOnce", void 0);

        _defineProperty(this, "_resolved", void 0);

        _defineProperty(this, "wrappedComponent", void 0);

        _defineProperty(this, "_ref", wc => {
          this.wrappedComponent = wc;

          if (wc) {
            Object(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_3__["hoistNonReactInstanceFunctions"])(this, wc);
            this._isModulesLoaded() && this._doLoad();
          }
        });

        this._doLoad();

        this.forceUpdateOnce = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["once"])(() => this.forceUpdate());
      }

      componentDidUpdate() {
        this._doLoad();
      }

      _doLoad() {
        if (this._isModulesLoaded() && !this._getResolved()) {
          doRequire(this);
        }
      }

      _isModulesLoaded() {
        return this.props.modulesLoaded !== false;
      }

      _getResolved() {
        if (!this._resolved) {
          if (!resolved) {
            const resolvedModules = {};
            const allResolved = Object.keys(imports).every(key => {
              if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
                return false;
              }

              resolvedModules[key] = this.props[key];
              return true;
            });

            if (allResolved) {
              this._resolved = resolvedModules;
            }
          } else {
            this._resolved = resolved;
          }
        }

        return this._resolved;
      }

      render() {
        const modulesLoaded = this._isModulesLoaded() && !!this._getResolved();

        if (!mountOnLoad || modulesLoaded) {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(WrappedComponent, _extends({}, this.props, resolved, {
            ref: this._ref,
            modulesLoaded: modulesLoaded
          }));
        }

        return null;
      }

    }

    _defineProperty(RequireAMD, "propTypes", {
      modulesLoaded: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
    });

    _defineProperty(RequireAMD, "WrappedComponent", void 0);

    RequireAMD.WrappedComponent = WrappedComponent;
    return RequireAMD;
  };
}); // Use this mixin to supply a new lifecycle function called 'componentDidLoadModules'
// This lifecycle function will be called once all modules have been loaded via requireAMD HOC.

function mixinComponentDidLoadModules(WrappedComponent) {
  const proto = WrappedComponent.prototype;

  if (proto.componentDidLoadModules) {
    const oriComponentDidMount = proto.componentDidMount;
    const oriComponentDidUpdate = proto.componentDidUpdate;

    proto.componentDidMount = function (...args) {
      // by checking !== false, tests can pass as props the mock modules and not have to also include modulesLoaded={true}
      if (this.props.modulesLoaded !== false) {
        this.componentDidLoadModules();
      }

      oriComponentDidMount && oriComponentDidMount.apply(this, args);
    };

    proto.componentDidUpdate = function (...args) {
      const [prevProps] = args;

      if (!prevProps.modulesLoaded && this.props.modulesLoaded) {
        this.componentDidLoadModules();
      }

      oriComponentDidUpdate && oriComponentDidUpdate.apply(this, args);
    };
  }
}

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon-toolkit");

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97);


/***/ }),

/***/ 92:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__92__;

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "bi/commons/utils/dnd/DnDManager"
var DnDManager_ = __webpack_require__(92);
var DnDManager_default = /*#__PURE__*/__webpack_require__.n(DnDManager_);

// EXTERNAL MODULE: external "@ba/ba-ui-carbon-toolkit"
var ba_ui_carbon_toolkit_ = __webpack_require__(12);

// CONCATENATED MODULE: ./src/common/utils/GlassDnDBackend.ts
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


const {
  getNodeClientOffset,
  getNodeDepth,
  getEventClientOffset,
  offsetWithinBoundingRect
} = ba_ui_carbon_toolkit_["domUtils"];

class GlassDnDBackend_GlassDnDBackend {
  constructor(manager, {
    deadzone = 5,
    glassDnD: glassDnDInst
  } = {}) {
    _defineProperty(this, "actions", void 0);

    _defineProperty(this, "monitor", void 0);

    _defineProperty(this, "registry", void 0);

    _defineProperty(this, "deadzone", void 0);

    _defineProperty(this, "_glassDnD", void 0);

    _defineProperty(this, "mouseClientOffset", void 0);

    _defineProperty(this, "targetNodes", void 0);

    _defineProperty(this, "sourceNodes", void 0);

    _defineProperty(this, "sourceNodesOptions", void 0);

    _defineProperty(this, "useAccepts", true);

    _defineProperty(this, "dropAllowed", false);

    _defineProperty(this, "targetDepths", void 0);

    _defineProperty(this, "_externalTargets", void 0);

    _defineProperty(this, "_timeoutId", void 0);

    _defineProperty(this, "getSourceClientOffset", sourceId => getNodeClientOffset(this.sourceNodes[sourceId]));

    _defineProperty(this, "handleWindowKeyDown", e => {
      // esc key
      if (e.keyCode === 27) {
        if (this.monitor.isDragging()) {
          this.actions.endDrag();
        }
      }
    });

    _defineProperty(this, "handleClear", () => {
      clearTimeout(this._timeoutId);
    });

    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.registry = manager.getRegistry();
    this.targetNodes = {};
    this.sourceNodes = {};
    this.sourceNodesOptions = {};
    this.targetDepths = {};
    this.mouseClientOffset = {};
    this.deadzone = deadzone;
    this._glassDnD = glassDnDInst;
  }

  get glassDnD() {
    return this._glassDnD || DnDManager_default.a;
  }

  setup() {
    if (typeof window === 'undefined') {
      return;
    }

    window.addEventListener('keydown', this.handleWindowKeyDown, true);
    window.addEventListener('mouseup', this.handleClear, true);
    window.addEventListener('touchend', this.handleClear, true);
  }

  teardown() {
    if (typeof window === 'undefined') {
      return;
    }

    this.mouseClientOffset = {};
    this.targetNodes = {};
    this.targetDepths = {};
    window.removeEventListener('keydown', this.handleWindowKeyDown, true);
    window.removeEventListener('mouseup', this.handleClear, true);
    window.removeEventListener('touchend', this.handleClear, true);
  }

  connectDragSource(sourceId, node, options) {
    this.sourceNodes[sourceId] = node;
    this.sourceNodesOptions[sourceId] = options || {};
    const handleMouseMoveStart = this.handleMouseMoveStart.bind(this, sourceId);
    const handleTouchMoveStart = this.handleTouchMoveStart.bind(this, sourceId);
    node.addEventListener('mousedown', handleMouseMoveStart);
    node.addEventListener('touchstart', handleTouchMoveStart);
    return () => {
      delete this.sourceNodes[sourceId];
      delete this.sourceNodesOptions[sourceId];
      node.removeEventListener('mousedown', handleMouseMoveStart);
      node.removeEventListener('touchstart', handleTouchMoveStart);
    };
  }

  connectDragPreview() {
    return false;
  }

  registerExternalDropTargets() {
    const {
      dropTargets
    } = this.glassDnD;
    this._externalTargets && this._externalTargets.forEach(targetId => {
      this.registry.removeTarget(targetId);
      delete this.targetDepths[targetId];
      delete this.targetNodes[targetId];
    });
    this._externalTargets = [];
    const allTypes = Object.keys(Object.keys(this.registry.types).reduce((typeMap, key) => {
      if (this.sourceNodes[key]) {
        typeMap[this.registry.types[key]] = true;
      }

      return typeMap;
    }, {}));
    dropTargets.forEach(({
      callbacks = {},
      el,
      selector
    }) => {
      if (el && selector !== '.dialogBlocker' && !callbacks.REACT_DND_INTERNAL) {
        const els = el.length ? Array.prototype.slice.call(el) : [el];
        els.forEach(domEl => {
          const targetId = this.registry.addTarget(allTypes, {
            canDrop: () => this.useAccepts ? !callbacks.accepts || callbacks.accepts(this.glassDnD.dragObject) : this.dropAllowed,

            hover() {},

            drop() {}

          });

          this._externalTargets.push(targetId);

          this.targetDepths[targetId] = getNodeDepth(domEl);
          this.targetNodes[targetId] = domEl;
        });
      }
    });
  }

  connectDropTarget(targetId, node) {
    this.targetDepths[targetId] = getNodeDepth(node);
    this.targetNodes[targetId] = node;
    const unsubscribe = this.glassDnD.addDropTarget(node, {
      priority: this.targetDepths[targetId],
      REACT_DND_INTERNAL: true
    }).remove;
    return () => {
      unsubscribe();
      delete this.targetNodes[targetId];
      delete this.targetDepths[targetId];
    };
  }

  handleMouseMoveStart(sourceId, e) {
    if (e.which !== 1) {
      return;
    }

    const target = e.currentTarget; // settimeout used to give react events a chance to fire first

    this._timeoutId = window.setTimeout(() => this.handleMoveStart(sourceId, e, target), 0);
  }

  handleTouchMoveStart(sourceId, e) {
    if (!e.touches || e.touches.length !== 1) {
      return;
    }

    const target = e.currentTarget; // settimeout used to give react events a chance to fire first

    this._timeoutId = window.setTimeout(() => this.handleMoveStart(sourceId, e, target), 0);
  }

  handleMoveStart(sourceId, e, target) {
    const handler = this.registry.handlers[sourceId];

    if (!handler || !handler.canDrag || !handler.canDrag()) {
      return;
    }

    const options = this.sourceNodesOptions[sourceId];
    let xPos = null;
    let yPos = null;

    if (options.restrictToYAxis) {
      xPos = target.getBoundingClientRect().left;
    }

    if (options.restrictToXAxis) {
      yPos = target.getBoundingClientRect().top;
    }

    this.glassDnD.startDrag({ ...options,
      event: e,
      moveXThreshold: this.deadzone,
      moveYThreshold: this.deadzone,
      callerCallbacks: {
        onDragStart: eDrag => {
          this.dropAllowed = false;
          this.useAccepts = true;
          this.registerExternalDropTargets();
          this.actions.beginDrag([sourceId], {
            clientOffset: getEventClientOffset(eDrag),
            getSourceClientOffset: this.getSourceClientOffset,
            publishSource: false
          });

          if (!this.monitor.isDragging()) {
            // This can occur of `canDrag` returns `false` from a react-dnd dragSource
            this.glassDnD.resetDragging();
          } else {
            this.actions.publishDragSource();
            const {
              dragObject
            } = this.glassDnD;
            dragObject.type = this.monitor.getItemType();
            dragObject.data = this.monitor.getItem();
          }
        },
        onDragDone: () => {
          this.dropAllowed = false;
          this.useAccepts = true;

          if (this.monitor.isDragging()) {
            this.actions.drop();
            this.actions.endDrag();
          }
        },
        onMove: (eDrag, data) => {
          const {
            dragObject,
            dropTargetNode
          } = data;
          this.useAccepts = !('dropTargetNode' in data);
          this.dropAllowed = !!dropTargetNode;

          if (this.monitor.isDragging()) {
            const clientOffset = getEventClientOffset(eDrag);

            if (xPos != null) {
              clientOffset.x = xPos;
            }

            if (yPos != null) {
              clientOffset.y = yPos;
            }

            const matchingTargetIds = Object.keys(this.targetNodes).filter(targetId => {
              // IE11 will throw if we do a getBoundingClientRect on an element that is not in the DOM
              // this try/catch will ignore those elements
              try {
                const boundingRect = this.targetNodes[targetId].getBoundingClientRect();
                return offsetWithinBoundingRect(clientOffset, boundingRect);
              } catch (e) {
                return false;
              }
            }).sort((targetIdA, targetIdB) => this.targetDepths[targetIdA] - this.targetDepths[targetIdB]);
            dragObject.clientOffset = clientOffset;
            this.actions.hover(matchingTargetIds, {
              clientOffset
            });
          }
        }
      }
    });
  }

}

function createBackend(optionsOrManager = {}) {
  const backendFactory = function (manager) {
    return new GlassDnDBackend_GlassDnDBackend(manager, optionsOrManager);
  };

  if (optionsOrManager.getMonitor) {
    return backendFactory(optionsOrManager);
  }

  return backendFactory;
}
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(34);

// CONCATENATED MODULE: ./src/common/utils/pseudo.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function pseudo_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ var pseudo = (function (Component) {
  return class Pseudo extends external_react_default.a.Component {
    constructor(...args) {
      super(...args);

      pseudo_defineProperty(this, "_node", void 0);

      pseudo_defineProperty(this, "_onMouseOver", () => {
        this.setState({
          hover: true
        });
      });

      pseudo_defineProperty(this, "_onMouseOut", () => {
        this.setState({
          hover: false
        });
      });

      pseudo_defineProperty(this, "_onMouseDown", () => {
        this.setState({
          active: true
        });
      });

      pseudo_defineProperty(this, "_onMouseUp", () => {
        this.setState({
          active: false
        });
      });
    }

    componentDidMount() {
      this._node.addEventListener('mouseenter', this._onMouseOver);

      this._node.addEventListener('mouseleave', this._onMouseOut);

      this._node.addEventListener('mousedown', this._onMouseDown);

      document.body.addEventListener('mouseup', this._onMouseUp);
    }

    componentWillUnmount() {
      this._node.removeEventListener('mouseenter', this._onMouseOver);

      this._node.removeEventListener('mouseleave', this._onMouseOut);

      this._node.removeEventListener('mousedown', this._onMouseDown);

      document.body.removeEventListener('mouseup', this._onMouseUp);
    }

    render() {
      return /*#__PURE__*/external_react_default.a.createElement(Component, _extends({}, this.props, this.state, {
        ref: r => this._node = Object(external_react_dom_["findDOMNode"])(r)
      }));
    }

  };
});
// CONCATENATED MODULE: ./src/common/utils/pureImmediateProps.tsx
function pureImmediateProps_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2017, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


function propsEqual(nextProps, prevProps) {
  const nextKeys = Object.keys(nextProps);
  const prevKeys = Object.keys(prevProps);
  return nextKeys.length === prevKeys.length && nextKeys.every(key => {
    if (key === 'children') {
      const newChildren = external_react_default.a.Children.toArray(nextProps[key]);
      const oldChildren = external_react_default.a.Children.toArray(prevProps[key]);
      return newChildren.length === oldChildren.length && newChildren.every((child, i) => {
        const oldChild = oldChildren[i];
        return child === oldChild || child && typeof child === 'object' && oldChild && typeof oldChild === 'object' && oldChild.key === child.key && oldChild.type === child.type && propsEqual(child.props, oldChild.props);
      });
    }

    return nextProps[key] === prevProps[key];
  });
}

function pureImmediateProps(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = class PureImmediatePropsComponent extends external_react_["Component"] {
    shouldComponentUpdate(nextProps) {
      return !propsEqual(nextProps, this.props);
    }

    render() {
      return /*#__PURE__*/external_react_default.a.createElement(WrappedComponent, this.props);
    }

  }, pureImmediateProps_defineProperty(_class, "WrappedComponent", WrappedComponent), _temp;
}
// EXTERNAL MODULE: ./src/common/utils/requireAMD.tsx
var requireAMD = __webpack_require__(11);

// CONCATENATED MODULE: ./src/common/utils/keyBinder.js
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-carbon-toolkit (C) Copyright IBM Corp. 2017,2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const controlKeys = {
  Meta: 'metaKey',
  Control: 'ctrlKey',
  Alt: 'altKey',
  Shift: 'shiftKey'
};

function generateMapKey(keyCodes, controlKeys) {
  return `${keyCodes.slice().sort().join(':')}::${controlKeys.slice().sort().join(':')}`;
}

function getKeyFromEvent(event, currentKeys) {
  const keyCodes = Object.keys(currentKeys).filter(k => currentKeys[k]);
  const pressedControlKeys = Object.keys(controlKeys).filter(k => event[controlKeys[k]]);
  return generateMapKey(keyCodes, pressedControlKeys);
}

function getKeyCode(e) {
  return e.key && e.key !== 'Unidentified' ? e.key : e.keyCode;
}

const keyBinder = () => {
  let boundElement;
  let enabled = false;
  const keyDownMap = {};
  let currentKeys = {};

  function keyDownListener(e) {
    const keyCode = getKeyCode(e);

    if (!controlKeys[keyCode]) {
      currentKeys[getKeyCode(e)] = true;
    }

    const key = getKeyFromEvent(e, currentKeys);
    const callback = keyDownMap[key];

    if (callback) {
      if (callback(e) !== false) {
        e.preventDefault();
      }
    }
  }

  function keyUpListener(e) {
    const key = getKeyCode(e); // Due to a "feature" in osx keyup events are not registered when Meta is held down

    if (key === 'Meta') {
      currentKeys = {};
    } else {
      currentKeys[getKeyCode(e)] = false;
    }
  }

  function focusListener() {
    currentKeys = {};
  }

  function updateListeners(add) {
    if (boundElement) {
      const fnName = add ? 'addEventListener' : 'removeEventListener';
      boundElement[fnName]('keydown', keyDownListener);
      boundElement[fnName]('keyup', keyUpListener);
      boundElement[fnName]('focusout', focusListener);
      boundElement[fnName]('focusin', focusListener);
    }
  }

  return {
    off(key) {
      return this.on(key, null);
    },

    on(keys, callback) {
      const allKeys = Array.isArray(keys) ? keys : [keys];
      const control = allKeys.filter(k => !!controlKeys[k]);
      const others = allKeys.filter(k => !controlKeys[k]);
      keyDownMap[generateMapKey(others, control)] = callback;
      return this;
    },

    setTarget(target) {
      // remove listeners
      enabled && updateListeners(false); // bind element

      boundElement = target; // re-add listeners

      target && enabled && updateListeners(true);
      return this;
    },

    enable(enable) {
      if (enable !== enabled) {
        updateListeners(enable);
      }

      enabled = enable;
      return this;
    }

  };
};

function isInputOrigin(e) {
  const {
    tagName
  } = e.target;

  if (tagName === 'TEXTAREA') {
    return true;
  }

  if (tagName === 'INPUT') {
    const type = e.target.type && e.target.type.toLowerCase();

    switch (type) {
      case 'email':
      case 'password':
      case 'number':
      case 'search':
      case 'tel':
      case 'text':
      case 'url':
        return true;

      default:
        return false;
    }
  }

  return false;
}

keyBinder.ignoreInputs = callback => e => {
  if (isInputOrigin(e)) {
    return false;
  }

  return callback(e);
};

/* harmony default export */ var utils_keyBinder = (keyBinder);
// CONCATENATED MODULE: ./src/common/utils/index.js
/* concated harmony reexport GlassDnDBackend */__webpack_require__.d(__webpack_exports__, "GlassDnDBackend", function() { return createBackend; });
/* concated harmony reexport pseudo */__webpack_require__.d(__webpack_exports__, "pseudo", function() { return pseudo; });
/* concated harmony reexport pureImmediateProps */__webpack_require__.d(__webpack_exports__, "pureImmediateProps", function() { return pureImmediateProps; });
/* concated harmony reexport requireAMD */__webpack_require__.d(__webpack_exports__, "requireAMD", function() { return requireAMD["default"]; });
/* concated harmony reexport mixinComponentDidLoadModules */__webpack_require__.d(__webpack_exports__, "mixinComponentDidLoadModules", function() { return requireAMD["mixinComponentDidLoadModules"]; });
/* concated harmony reexport keyBinder */__webpack_require__.d(__webpack_exports__, "keyBinder", function() { return utils_keyBinder; });
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */







/***/ })

/******/ });
});